import axios from "axios";
import { toast } from "react-toastify";
import {
  ADVANCE_FETCH_REQUEST,
  ADVANCE_FETCH_SUCCESS,
  ADVANCE_FETCH_FAILURE,
} from "../../types/HrTypes";

export const loadAllAdvances = (params = {}) => async (dispatch) => {
  dispatch({ type: ADVANCE_FETCH_REQUEST });
  try {
    const { data } = await axios.get("hr/advance", { params });
    dispatch({ type: ADVANCE_FETCH_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: ADVANCE_FETCH_FAILURE, payload: error.message });
  }
};

export const createAdvance = (values) => async () => {
  try {
    const { data } = await axios.post("hr/advance", values);
    toast.success("Advance recorded");
    return { message: "success", data };
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return { message: "error" };
  }
};

export const updateAdvance = (id, values) => async () => {
  try {
    const { data } = await axios.put(`hr/advance/${id}`, values);
    toast.success("Advance updated");
    return { message: "success", data };
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return { message: "error" };
  }
};

export const deleteAdvance = (id) => async () => {
  try {
    await axios.delete(`hr/advance/${id}`);
    toast.warning("Advance deleted");
    return { message: "success" };
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return { message: "error" };
  }
};
